import React, { useState, useEffect } from "react";
import DefaultLayout from "../reusableComponents/defaultLayout";
import OutForBid from "../components/outForBid";
import ActiveProjects from "../components/activeProjects";
import GenttChart from "../components/genttChart";
import MyContacts from "../components/myContacts";
import Profile from "../components/profile";
import Upload from "../components/uploadFile";
import AccountHeader from "../components/account/AccountHeader";
import { useNavigate, useParams } from "react-router-dom";

function Account() {
  const [activeTab, setActiveTab] = useState(null);
  const navigate = useNavigate();
  const { tabId } = useParams();

  useEffect(() => {
    const initialTabId = 0 <= tabId && tabId <= 5 ? parseInt(tabId) : 0;
    setActiveTab(initialTabId);
  }, [tabId]);

  const handleTabChange = (tabId) => {
    // Handle dashboard tab specially - it has its own route
    if (tabId === 'dashboard') {
      navigate('/dashboard');
      return;
    }
    setActiveTab(tabId);
    navigate(`/account/${tabId}`);
  };

  const renderTabContent = () => {
    switch (activeTab) {
      case 0:
        return <Profile />;
      case 1:
        return <OutForBid />;
      case 2:
        return <ActiveProjects />;
      case 3:
        return <GenttChart role="other" />;
      case 4:
        return <MyContacts onTabChange={handleTabChange} />;
      case 5:
        return <Upload onTabChange={handleTabChange} />;
      default:
        return null;
    }
  };

  return (
    <DefaultLayout>
      <AccountHeader activeTab={activeTab} onTabChange={handleTabChange} />
      <section className="account_content">
        {renderTabContent()}
      </section>
    </DefaultLayout>
  );
}

export default Account;
